var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb_age-gate_checkbox"},[_c('label',{staticClass:"sb_checkbox"},[_vm._t("default"),_c('span',{staticClass:"sb_checkbox_checkmark"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }